module.exports = __webpack_public_path__ + "static/media/cancel.c1f5e26e.png";